//DEV
// export const DB_CONFIG = {
//     apiKey: "AIzaSyCkn4KMq6Zu9gjqOc6MHRa4SOGstijznPg",
//     authDomain: "ln-consultoria-esportiva.firebaseapp.com",
//     databaseURL: "https://ln-consultoria-esportiva.firebaseio.com",
//     projectId: "ln-consultoria-esportiva",
//     storageBucket: "ln-consultoria-esportiva.appspot.com",
//     messagingSenderId: "61279497448"
// };

//Lucas
// export const DB_CONFIG = {
//     apiKey: "AIzaSyCw_al9VBhX5rF2f2Qe6tr-WnyUtarwQHI",
//     authDomain: "app-training-2d29d.firebaseapp.com",
//     databaseURL: "https://app-training-2d29d.firebaseio.com",
//     projectId: "app-training-2d29d",
//     storageBucket: "app-training-2d29d.appspot.com",
//     messagingSenderId: "965333846362"
// };

//Ary
export const DB_CONFIG = {
    apiKey: "AIzaSyBZ5d9YeCPHBqgSH5Wz87KOE-g2qs1YK90",
    authDomain: "ary-training.firebaseapp.com",
    databaseURL: "https://ary-training.firebaseio.com",
    projectId: "ary-training",
    storageBucket: "ary-training.appspot.com",
    messagingSenderId: "188743466766"
};

//FamilyFit
// export const DB_CONFIG = {
//     apiKey: "AIzaSyDaMrvJ3LwpH2lUwFo1y1XIuvCaiW6vsh8",
//     authDomain: "family-fit-training-bbd2f.firebaseapp.com",
//     databaseURL: "https://family-fit-training-bbd2f.firebaseio.com",
//     projectId: "family-fit-training-bbd2f",
//     storageBucket: "family-fit-training-bbd2f.appspot.com",
//     messagingSenderId: "801796415758"
// };


// WEBPACK FOOTER //
// src/config/config.js